import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';

export async function getReserveList(form:any) {    
    return axiosWithAuthInterceptor.get(
        `${process.env.REACT_APP_LIMOOME_SERVER}/lemonade/api/diet-packages/?where%5Bdiets%5D[some][status][equals]=RESERVED&where%5Bmobile%5D[equals]=${form.mobile}`).then(res => {
        return res
    })

}

export async function changeStatusReserveDiet(param:any) {    
    return axiosWithAuthInterceptor.patch(`${process.env.REACT_APP_LIMOOME_SERVER}/lemonade/api/limoome-integrations/diets/${param.id}`,{status:param.status}).
    then(res => {
        return res
    })

}


export async function transferReservedDiet(param:any) {    
    return axiosWithAuthInterceptor.patch(`${process.env.REACT_APP_LIMOOME_SERVER}/lemonade/api/diet-packages/${param.index}/user`,{mobile:param.mobile}).
    then(res => {
        return res
    })

}